export const formatDate = (createdAt) => {
  const date = new Date(createdAt);
  const day = date.getDate();
  const month = date.toLocaleString("kk-KZ", { month: "long" }).toLowerCase();
  const year = date.getFullYear();
  return `${day} ${month} ${year} ж.`;
};
